import { useNavigate } from 'react-router-dom'
import { RUB } from './format'

/**
 * Гаджет: затраты по машинам.
 *
 * Называется «затраты», а не «стоимость владения»: лизинга, страховых
 * платежей и зарплаты водителя в системе нет. По этой цифре принимают
 * решение «чинить или менять», и завышать её полноту названием нельзя.
 */
export function CarOwnershipCostWidget({ data }) {
  const navigate = useNavigate()

  if (!data.rows.length) {
    return <p className="widget-empty">За период расходов по машинам не было</p>
  }

  return (
    <div className="tco">
      <table className="tco__table">
        <caption className="visually-hidden">
          Затраты на машину за {data.period_days ?? '—'} дней
        </caption>
        <thead>
          <tr>
            <th scope="col">Машина</th>
            <th scope="col" className="tco__num">₽/км</th>
            <th scope="col" className="tco__num">Всего</th>
            <th scope="col" className="tco__num">Ремонтов</th>
            <th scope="col" className="tco__num">Пробег</th>
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.car_id}>
              <th scope="row">
                <button
                  type="button"
                  className="tco__link"
                  onClick={() => navigate(`/admin/cars/${r.car_id}`)}
                >
                  {r.car}
                  {r.plate ? <span className="plate">{r.plate}</span> : null}
                </button>
              </th>
              <td className="tco__num tco__rate">
                {r.per_km != null ? r.per_km : '—'}
              </td>
              <td className="tco__num">{RUB.format(r.total)} ₽</td>
              <td className="tco__num">{r.repairs || '—'}</td>
              <td className="tco__num">
                {r.distance ? `${RUB.format(r.distance)} км` : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="widget-note">
        Учтены расходы по рейсам и ремонты. Лизинг, страховые платежи
        и оплата труда в системе не хранятся — полной стоимостью владения
        эта цифра не является.
      </p>
    </div>
  )
}
